var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43527",
    "data-name": "Group 43527",
    transform: "translate(-194 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16123",
    "data-name": "Rectangle 16123",
    width: 24,
    height: 24,
    transform: "translate(194 80)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Process",
    transform: "translate(175.5 61.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3143",
    "data-name": "Ellipse 3143",
    cx: 2.669,
    cy: 2.669,
    r: 2.669,
    transform: "translate(20 27.83)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3144",
    "data-name": "Ellipse 3144",
    cx: 2.669,
    cy: 2.669,
    r: 2.669,
    transform: "translate(35.661 27.83)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3145",
    "data-name": "Ellipse 3145",
    cx: 2.669,
    cy: 2.669,
    r: 2.669,
    transform: "translate(27.83 20)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3146",
    "data-name": "Ellipse 3146",
    cx: 2.669,
    cy: 2.669,
    r: 2.669,
    transform: "translate(27.83 35.661)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37255",
    "data-name": "Path 37255",
    d: "M316,80h4.271a1.78,1.78,0,0,1,1.78,1.78v3.533",
    transform: "translate(-282.831 -57.331)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3348",
    "data-name": "Line 3348",
    x1: 10.322,
    transform: "translate(25.339 30.5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37256",
    "data-name": "Path 37256",
    d: "M60,312.586v3.533a1.78,1.78,0,0,0,1.78,1.78h4.271",
    transform: "translate(-38.22 -279.568)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3349",
    "data-name": "Line 3349",
    x2: 7.83,
    transform: "translate(33.169 38.33)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3350",
    "data-name": "Line 3350",
    x1: 3.381,
    transform: "translate(20 22.669)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37257",
    "data-name": "Path 37257",
    d: "M96,43.559l1.78-1.78L96,40",
    transform: "translate(-72.619 -19.11)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37258",
    "data-name": "Path 37258",
    d: "M452,395.559l1.78-1.78L452,392",
    transform: "translate(-412.78 -355.449)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormHandle);
export default __webpack_public_path__ + "static/media/form-handle.4913e319038230848f5b708530de862b.svg";
export { ForwardRef as ReactComponent };